export interface PoliceExtractType {
	key: string;
	labelKey: string;
	validityMonths?: number;
}

export const POLICE_EXTRACT_TYPES: PoliceExtractType[] = [
	{ key: "school", labelKey: "POLICE_EXTRACT_TYPE_SCHOOL", validityMonths: 12 },
	{ key: "care", labelKey: "POLICE_EXTRACT_TYPE_CARE" },
];

export const policeExtractCertKey = (typeKey: string) => `POLICE_RECORD_EXTRACTS:${typeKey}`;
